import reportBg from "../../../assets/portada.jpg"; // Import the background image
import { datesAtom } from "@/store/dates";
import { useAtom } from "jotai";
import { prepareDisplayDate } from "@/lib/utils";
import ReportHeader from "@/components/ReportHeader";
import { useTranslation } from "react-i18next";

const CoverPage = () => {
  const { t } = useTranslation();
  const [dates] = useAtom(datesAtom);

  return (
    <section
      className="pdf-page relative flex flex-col justify-between p-[60px_40px] text-white"
      style={{
        backgroundImage: `url(${reportBg})`,
        backgroundSize: "cover",
        backgroundPosition: "left",
        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
      }}
    >
      <ReportHeader />
      <div className="relative z-10 flex flex-col h-full">
        <div className="mt-[280px] pb-10">
          <h2 className="text-2xl leading-[1] font-bold text-[#f0f0f0] my-8 max-w-[800px]">
            {t("Análisis de huella de carbono de")}{" "}
            <span className="text-primary">
              {prepareDisplayDate(dates?.fromDate)?.toLocaleDateString()}{" "}
              {t("a")} {prepareDisplayDate(dates?.toDate)?.toLocaleDateString()}
            </span>
          </h2>
          <p className="  text-xl leading-[1.2] text-[#e0e0e0] max-w-[600px]">
            *
            {t(
              "La visualización de tipo consolidado no va de acuerdo al estándar GHG Protocol para organizaciones de tipo holding y/o con organizaciones participadas",
            )}
            .
          </p>
        </div>
      </div>
    </section>
  );
};

export default CoverPage;
